export default "__VITE_ASSET__OYKI7hJu__"